<template>
<div>
    <HeaderContent header="แก้ไขบทความใหม่" :img_header="header_image" link_back="contentblog" />
    <ContentEditBlogList />
</div>
</template>

<script>
import HeaderImage from '@/assets/copywriting.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import ContentEditBlogList from '@/components/menuadmin/content/contentblog/ContentEditBlogList.vue'

export default {
    name: 'contentEditBlog',
    components: {
        HeaderContent,
        ContentEditBlogList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
